module.exports = __webpack_public_path__ + "img/tu02.7579da65.png";